// extracted by mini-css-extract-plugin
export default {"animatedImageContainer":"form-page_animatedImageContainer__i2UVD"};